import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { EVENTS_STRINGS } from '../constants/events-strings';
import { GuestRegistrationModal } from './GuestRegistrationModal';

interface GuestRegisterCTAProps {
  eventId: string;
  isClosed: boolean;
  /** Re-read the remembered state once the visitor has registered and closed the modal. */
  onRegistered: () => void;
}

/**
 * The Register action for a logged-out visitor (FR-282): a button that opens the
 * registration modal rather than leading to login. A closed event keeps its
 * disabled button, as for a member.
 */
export function GuestRegisterCTA({ eventId, isClosed, onRegistered }: GuestRegisterCTAProps) {
  const [open, setOpen] = useState(false);

  if (isClosed) {
    return (
      <Button variant="primary" className="w-full" disabled>
        {EVENTS_STRINGS.DETAIL.REGISTRATION_CLOSED}
      </Button>
    );
  }
  return (
    <>
      <Button variant="chip-green" className="w-full" onClick={() => setOpen(true)}>
        {EVENTS_STRINGS.REGISTER}
      </Button>
      <GuestRegistrationModal eventId={eventId} open={open} onOpenChange={setOpen} onRegistered={onRegistered} />
    </>
  );
}
